import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { Globle } from 'src/assets/globle';
import { Menu } from '../menu/menu.model';
import { MenuService } from '../menu/menu.service';
import { Permission } from './permission.model';
import { PermissionService } from './permission.service';
import { Users } from 'src/app/options/users/users.model';
import { UsersService } from 'src/app/options/users/users.service';

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.css']
})
export class PermissionsComponent implements OnInit {

  roles: { id: string, name: string }[] = [];
  users: Users[] = [];
  menus: Menu[] = [];
  permission: Permission = {} as Permission;
  permissions: Permission[] = [];
  displayedColumns: string[] = ['menuItemId', 'menuItemName', 'view'];
  dataSource!: MatTableDataSource<Permission>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  selectedRole!: string;
  selectedUser = null;
  selectedMenu!: number;
  pageSize = 100;

  constructor(private translate: TranslateService,
    private menuService: MenuService,
    private service: PermissionService,
    private globle: Globle,
    private usersService: UsersService,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.pageSize = this.globle.pageSize;
    // this.roles = [{ id: "dc1da5d0-d8f8-4616-8b46-d0bef56083b0", name: "مساعد" },
    // { id: "d2cab955-ba3f-4f1b-92e3-d3fd91b75295", name: "مندوب" }
    // ];
    this.getRoles();

  }

  getRoles() {
    this.service.getRoles().subscribe(data => {
      this.roles = data.filter(x => x["name"] == "Assistant" || x["name"] == "Mandoob");
    })
  }

  OnSelectedUser() {
    this.getMenu();
  }

  getUsersByRoles() {
    this.spinnerOverlay = true;
    var roleName = this.roles.find(x => x.id == this.selectedRole)?.name;
    this.usersService.getUsersByRole(roleName).subscribe(data => {
      this.users = data;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  getMenu() {
    this.spinnerOverlay = true;
    this.menuService.getAll().subscribe(data => {
      this.menus = data;
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  getItemMenuWithPermission() {
    this.spinnerOverlay = true;

    this.service.getAll(this.selectedMenu, this.selectedUser).subscribe(data => {
      this.permissions = data;
      this.dataSource = new MatTableDataSource(this.permissions);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
    });

  }


  OnSelectedMenu() {

    this.getItemMenuWithPermission();
  }

  OnSelectedRole() {
    this.selectedUser = null;
    this.getUsersByRoles()
    this.menus = [];
    this.permissions = [];
    this.dataSource = new MatTableDataSource(this.permissions);
    this.dataSource.paginator = this.paginator;
    // if (this.selectedMenu != null && this.selectedMenu != undefined) {
    //   this.getItemMenuWithPermission();
    // }
  }

  save() {
    this.spinnerOverlay = true;

    let menuPermArray = [];
    for (let i = 0; i < this.permissions.length; i++) {
      //if (this.permissions[i].view) {
      let menuPermObj = {
        "role_id": this.selectedRole,
        "menu_item_id": this.permissions[i].menuItemId,
        "view": this.permissions[i].view,
        "userId": this.selectedUser
      }

      menuPermArray.push(menuPermObj);
      // }
    }

    this.service.Create(menuPermArray).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("createdSuccessfully"), 'snackBarSuccess');
    }, error => {
      console.log(error);
      if (error.error.message != undefined) {
        this.openSnackBar(error.error.message, 'snackBarError');
      }
      else {
        this.openSnackBar("Internal server error", 'snackBarError');
      }

      this.spinnerOverlay = false;
    })
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass

    });
  }
}
